// es translations
export const ES_TRANSLATIONS: { [key: string]: string } = {
    "chineseLanguageLabel": "Chino",
    "punjabiLanguageLabel": "Punjabi",
    "spanishLanguageLabel": "Español",

    "--DropoffLateReason": "-- Motivo de entrega tardía --",
    "--FundingSource--": "-- Fuente de financiamiento --",
    "--PickupLateReason": "-- Motivo de recogida tardía --",
    "--Seats--": "-- Asientos --",
    "--Select--": "-- Seleccionar --",
    "--SelectAccountStatus": "-- Seleccione Estado de cuenta --",
    "--SelectAssist--": "-- Seleccione Asistencia --",
    "--SelectBodyType": "-- Seleccionar tipo de cuerpo --",
    "--SelectBroker--": "-- Seleccionar corredor --",
    "--SelectCancelReasons": "-- Seleccione Motivos de cancelación --",
    "--SelectCapacity--": "-- Seleccionar capacidad --",
    "--SelectCompetency--": "-- Seleccione Competencia --",
    "--SelectCorporateUser": "-- Seleccionar Usuario Corporativo --",
    "--SelectDateFormat": "-- Seleccionar formato de fecha --",
    "--SelectDay--": "-- Seleccionar día --",
    "--SelectDiagnosismedicalCond": "-- Seleccione Diagnóstico/Condición Médica --",
    "--SelectDoModifier": "-- Seleccione Modificador DO --",
    "--SelectDrivers--": "-- Seleccionar controladores --",
    "--SelectDrivers--2": "-- Seleccionar conductores --",
    "--SelectEmploymentType": "-- Seleccionar tipo de empleo --",
    "--SelectEquipment--": "-- Seleccionar Equipo --",
    "--SelectFleet--": "-- Seleccionar Flota --",
    "--SelectFs--": "-- Seleccione FS --",
    "--SelectFuelType": "-- Seleccione el tipo de combustible --",
    "--SelectGroup--": "-- Seleccionar grupo --",
    "--SelectMapper--": "-- Seleccionar mapeador --",
    "--SelectMemberRole": "-- Seleccionar rol de miembro --",
    "--SelectMethod--": "-- Seleccionar método --",
    "--SelectMonth--": "-- Seleccionar mes --",
    "--SelectOperationsManager": "-- Seleccione Gerente de Operaciones --",
    "--SelectPlatformportal--": "-- Seleccionar Plataforma/Portal --",
    "--SelectPosition--": "-- Seleccionar posición --",
    "--SelectProficiency--": "-- Seleccione Competencia --",
    "--SelectPuModifier": "-- Seleccione Modificador PU --",
    "--SelectReason--": "-- Seleccionar motivo --",
    "--SelectRoleType": "-- Seleccionar tipo de rol --",
    "--SelectServiceAreas": "-- Seleccionar área(s) de servicio --",
    "--SelectShiftAlign": "-- Seleccione Mayús Alinear --",
    "--SelectSpacetype--": "-- Seleccione Tipo de espacio --",
    "--SelectStateCode": "-- Seleccionar código de estado --",
    "--SelectStationManager": "-- Seleccione Administrador de estación --",
    "--SelectStatus--": "-- Seleccionar Estado --",
    "--SelectStatuss--": "-- Seleccionar estado(s) --",
    "--SelectTemplate--": "-- Seleccionar plantilla --",
    "--SelectTimeFormat": "-- Seleccionar formato de hora --",
    "--SelectType--": "-- Seleccionar tipo --",
    "--SelectVehicle--": "-- Seleccionar vehículo --",
    "--ServiceArea--": "-- Área de Servicio --",
    "--SpaceType--": "-- Tipo de espacio --",
    "--selectRequiredOdometer--": "--Seleccione el odómetro requerido--",
    "--selectStatus--": "--Seleccione Estado--",
    "-selectFundingSource-": "-Seleccione fuente de financiamiento-",
    "10min": "10 minutos",
    "15min": "15 minutos",
    "1HourViolation": "Violación de 1 hora",
    "30min": "30 minutos",
    "Amendments": "Enmiendas",
    "Announcement": "Anuncio",
    "Cities Zones": "Zonas de ciudades",
    "Companies": "Empresas",
    "Drivers": "Conductores",
    "Drivers Load": "Carga de controladores",
    "Equipment Planning": "Planificación de equipos",
    "Equipments": "Equipos",
    "Funding Sources": "Fuentes de financiamiento",
    "Holidays": "Vacaciones",
    "Late Forecast": "Pronóstico tardío",
    "Late Reasons": "Razones tardías",
    "Level of Service": "Nivel de servicio",
    "Mapper": "Mapeador",
    "Members": "Miembros",
    "Miles For Bucks": "Millas por dólares",
    "New Trip": "Nuevo viaje",
    "Offered": "Ofrecido",
    "Payors": "Pagadores",
    "Profiling": "Perfilado",
    "Quarters": "Cuartos",
    "Schedule": "Horario",
    "Service Areas": "Áreas de servicio",
    "Shift Override": "Anulación de turno",
    "Space Type Checklist": "Lista de verificación del tipo de espacio",
    "Space Types": "Tipos de espacio",
    "Staff": "Personal",
    "Standing Orders": "Órdenes permanentes",
    "Templates": "Plantillas",
    "Timesheet": "Hoja de horas",
    "Trip Sheet": "Hoja de viaje",
    "Vehicles": "Vehículos",
    "Violations": "Violaciones",
    "aaccountStatusIsRequired": "Se requiere un estado de cuenta",
    "accept": "Aceptar",
    "accepted": "Aceptado",
    "acceptedTrips": "Viajes aceptados",
    "accidentAndIncidentTraining": "Capacitación sobre accidentes e incidentes",
    "accountStatus": "Estado de la cuenta",
    "accountStatusIsRequired": "Se requiere estado de cuenta",
    "acknowledgeByDriver": "Reconocimiento por parte del conductor",
    "act": "actuar",
    "action": "ACCIÓN",
    "actions": "Acciones",
    "actualShift": "Turno real",
    "add": "+ Agregar",
    "addAddon": "Agregar complemento",
    "addAmendment": "Agregar enmienda",
    "addAnnouncement": "Agregar anuncio",
    "addAppointmentType": "Agregar tipo de cita",
    "addBeneficiary": "Agregar beneficiario",
    "addBreak": "Agregar descanso",
    "addBroker": "Agregar corredor",
    "addCancelReason": "Agregar motivo de cancelación",
    "addChecklist": "Agregar lista de verificación",
    "addCity": "Agregar ciudad",
    "addCompany": "Agregar empresa",
    "addDistribution": "Agregar distribución",
    "addDriver": "Agregar controlador",
    "addEquipment": "Agregar equipo",
    "addFundingSource": "Agregar fuente de financiamiento",
    "addHoliday": "Agregar vacaciones",
    "addLegButton": "+ Pierna",
    "addLevelOfService": "Agregar nivel de servicio",
    "addMapper": "Agregar asignador",
    "addMember": "Agregar miembro",
    "addModifierCode": "Agregar código modificador",
    "addPayor": "Agregar pagador",
    "addPrimaryDiagnose": "Agregar diagnóstico primario",
    "addQuarter": "Agregar trimestre",
    "addRate": "Agregar tarifa",
    "addReason": "Agregar motivo",
    "addServiceArea": "Agregar área de servicio",
    "addShift": "Agregar turno",
    "addShiftOverride": "Agregar anulación de turno",
    "addSpaceType": "Agregar tipo de espacio",
    "addStaff": "Agregar personal",
    "addTemplate": "Agregar plantilla",
    "addTips": "Agregar consejos",
    "addTripHeader": "Añadir",
    "addVehicle": "Agregar vehículo",
    "addYourComment": "Añade tu comentario",
    "addYourComment2": "Añade tu comentario...",
    "addZone": "Agregar zona",
    "additionalInformation": "Información adicional",
    "additionalNote": "Nota adicional",
    "addonButton": "+ Complemento",
    "addonItemLabel": "Artículo",
    "addonItemRequired": "Se requiere artículo",
    "addonServicesHeader": "Servicios complementarios",
    "address": "Dirección:",
    "addressLabel": "Dirección",
    "addressName": "Nombre de dirección",
    "addressNameIsRequired": "Dirección El nombre es obligatorio",
    "addressRequired": "Se requiere dirección",
    "addressValidationAlert": "Alerta de validación de dirección",
    "addupdateSignature": "Agregar/actualizar firma",
    "adjustTrip": "Ajustar viaje",
    "adjustment": "Ajuste",
    "adlAmbulanceDriversLicense": "ADL (LICENCIA DE CONDUCIR DE AMBULANCIA)",
    "adlImageIsRequired": "Se requiere imagen ADL",
    "admin": "administrador",
    "agent": "Agente",
    "alarming": "Alarmante",
    "alarmingTrips": "Viajes alarmantes",
    "alcReminder": "Recordatorio de ALC",
    "alcoholScreeningRecentScreen": "Prueba de detección de alcohol (prueba reciente)",
    "algorithm": "Algoritmo",
    "all": "Todos",
    "allDrivers": "Todos los conductores",
    "allMessages": "Todos los mensajes",
    "allNotifications": "Todas las notificaciones",
    "allowAttendee": "Permitir asistente",
    "allowAuthorizationNumberFor": "Permitir número de autorización para One Care",
    "allowPlacement": "Permitir ubicación",
    "allowCamera": "Permitir cámara",
    "allowCapacityViolation": "Permitir violación de capacidad",
    "allowCapacityViolations": "Permitir violaciones de capacidad",
    "allowIncentive": "Permitir incentivo",
    "allowIpcr": "Permitir IPCR",
    "allowAuditLogs": "Permitir registros de auditoría",
    "allowCoverage": "Permitir cobertura",
    "auditlogs": "Registros de auditoría",
    "allowMulti-factorAuthenticat": "Permitir la autenticación multifactor",
    "allowNearBy": "Permitir cerca",
    "allowOnboardViolations": "Permitir infracciones a bordo",
    "allowPossibility": "Permitir posibilidad",
    "allowSms": "Permitir SMS",
    "allowTimesheet": "Permitir parte de horas",
    "allowVoiceAssistance": "Permitir asistencia de voz",
    "ambulance": "Ambulancia",
    "ambulette": "Ambuleta",
    "amendment": "Enmienda",
    "amountIsRequired": "Se requiere cantidad",
    "announcements": "Anuncios",
    "api": "API",
    "appealed": "Apelado",
    "appky": "aplicación",
    "applyIncentive": "Aplicar incentivo",
    "appointmentDirectionInside": "Centro interior",
    "appointmentDirectionLabel": "Dirección de cita",
    "appointmentDirectionOutside": "Centro exterior",
    "appointmentTime": "Hora de la cita",
    "appointmentTimeIsRequired": "Se requiere hora de cita",
    "appointmentTypeLabel": "Tipo de cita",
    "appointmentTypeRequired": "Se requiere tipo de cita",
    "appointmentTypefileIsRequire": "Se requiere tipo de cita (archivo)",
    "appointmentTypetpIsRequired": "Se requiere tipo de cita (TP)",
    "approachingAlert": "Alerta de aproximación",
    "approachingTrips": "Viajes próximos",
    "approve": "Aprobar",
    "approved": "Aprobado",
    "aptOrSuiteIs": "Se requiere APT o Suite",
    "aptOrSuiteLabel": "APARTAMENTO/SUITE",
    "aptOrSuiteRequired": "Se requiere APT/SUITE",
    "aptsuiteroom": "Apto/Suite/Habitación",
    "arabicLanguageLabel": "Árabe",
    "archive": "Archivo",
    "archived": "Archivado",
    "archivedTrips": "Viajes archivados",
    "areYouSureYou": "¿Estás seguro de que quieres trasladar este viaje a un nuevo momento?",
    "areYouSureYou2": "¿Estás seguro de que quieres cancelar?",
    "areYouSureYou3": "¿Está seguro de que desea actualizar el odómetro?",
    "areYouSureYou4": "¿Está seguro de que desea crear un viaje a partir de la orden permanente principal en esta fecha en particular?",
    "areYouSureYou5": "¿Está seguro de que desea borrar todos los datos de viajes del sistema? ¿Tendrá que volver a importar los datos para asignar cualquier viaje al conductor, ya que se trata de una acción permanente?",
    "arn": "ARN",
    "arrears": "Atrasos",
    "arrearsLabel": "Etiqueta de atrasos",
    "arrived": "Llegó",
    "assign": "Asignar",
    "assignTrip": "Asignar viaje",
    "assignMultipleTrips": "Asignar múltiples viajes",
    "assignVehicle": "Asignar vehículo",
    "assignedTrips": "Viajes asignados",
    "assist": "ayudar",
    "assistShiftAlign": "Alinear cambios de asistencia",
    "assistShiftAlignIs": "Se requiere asistencia de alineación de cambios",
    "assistShiftDayWise": "Turno de asistencia (diurno)",
    "assistShiftEnd": "Asistencia al final del turno",
    "assistShiftEndIs": "Se requiere asistencia al final del turno",
    "assistShiftStart": "Inicio de cambio asistido",
    "assistShiftStartIs": "Se requiere inicio de cambio asistido",
    "assistsLabel": "Asistencias",
    "associateImage": "Imagen asociada",
    "atLeastOneAssist": "Se requiere al menos un turno de asistencia",
    "atleastOneDayShift": "Se requiere al menos un turno de día.",
    "atleastOneDriverIs": "Se requiere al menos un conductor",
    "attachPdfButton": "Adjuntar PDF",
    "attchedPdf": "Pdf adjunto",
    "authNumberLabel": "Número de autorización",
    "authorizationNumberIsRequire": "Se requiere número de autorización",
    "authorizer": "Autorizador",
    "autoAssignWillCall": "La asignación automática llamará",
    "autoGenerate": "Generación automática",
    "autoRefresh": "Actualización automática",
    "autoTimeStamp": "Marca de tiempo automática",
    "autoTimestamp": "Marca de tiempo automática",
    "autoZoom": "Zoom automático",
    "available": "Disponible",
    "avatar": "avatar",
    "backToLogin": "Volver a iniciar sesión",
    "background": "Antecedentes",
    "badPhonenumber": "Número de teléfono incorrecto",
    "banked": "bancarizado",
    "baseFare": "Tarifa básica",
    "baseFareCode": "Código de tarifa base",
    "baseFareCodeIs": "Se requiere el código de tarifa base",
    "baseFareFor": "Tarifa base para",
    "baseFareForIs": "Se requiere tarifa base para",
    "baseFareIsRequired": "Se requiere tarifa base",
    "batch": "lote",
    "bedBugProtocol": "Protocolo contra chinches",
    "bedLengthIsRequired": "Se requiere la longitud de la cama",
    "beginAt": "Comience en:",
    "billTo": "Facturar a *",
    "billerNote": "Nota del facturador",
    "billerNotes": "Notas del facturador",
    "billing": "Facturación",
    "bloodbornePathogenTrainingEx": "Entrenamiento sobre patógenos transmitidos por la sangre (EXP)",
    "bloodbornePathogens": "Patógenos transmitidos por la sangre",
    "bodyType": "Tipo de cuerpo",
    "bodyTypeIsRequired": "Se requiere tipo de cuerpo",
    "both": "ambos",
    "break": "descanso",
    "breakCushion": "Cojín de descanso:",
    "breakFinished": "Descanso (Terminado)",
    "breakScheduled": "Descanso (programado)",
    "breaks": "Descansos",
    "broker-img": "corredor-img",
    "brokerConfiguration": "Configuración del corredor",
    "brokerId": "ID del corredor",
    "brokerIsRequired": "Se requiere corredor",
    "bsr": "BSR",
    "bsr2": "RSB:",
    "bulkConfirmation": "Confirmación masiva",
    "businessNumber": "Número de negocio",
    "businessNumberIsRequired": "Se requiere número comercial",
    "businessReport": "Informe comercial",
    "businessReports": "Informes comerciales",
    "busy": "Ocupado",
    "bySavingTheInformation": "Al guardar la información en este formulario, usted da fe, como representante autorizado de la organización, que la información refleja fielmente los transportes realizados por la misma. Por la presente certifica que esta información es verdadera, precisa y completa a su leal saber y entender y comprende que cualquier falsificación, omisión u ocultación de un hecho material puede exponerlo a usted y/o a la organización a responsabilidad contractual, administrativa, civil o penal. Además, comprende que toda la documentación para estos transportes debe mantenerse de acuerdo con las políticas de mantenimiento de registros de los respectivos corredores de seguros y sus afiliados.",
    "caTimesheet": "Hoja de horas de California",
    "calculateButton": "calcular",
    "calculateLocalMiles": "Calcular millas locales",
    "call": "llamar",
    "callMemberToVerify": "Llame al miembro para verificar la cancelación",
    "cancel": "Cancelar",
    "cancelCharges": "Cancelar cargos",
    "cancelChargesIsRequired": "Se requieren cargos de cancelación",
    "cancelReason": "Cancelar motivo",
    "cancelReasons": "Cancelar razones",
    "cancelReasonsIsRequired": "Se requieren motivos de cancelación",
    "cancelTrip": "Cancelar viaje",
    "canceled": "Cancelado",
    "cancellationNotes": "Notas de cancelación",
    "cancelled": "Cancelado",
    "cancelledAt": "Cancelado en:",
    "cancelledFee": "Tarifa cancelada *",
    "cancelledTripsSection": "Sección de viajes cancelados",
    "capacities": "Capacidades",
    "capacity": "Capacidad",
    "capacityIsRequired": "Se requiere capacidad",
    "careGiverInformation": "Información del cuidador",
    "caregiverDetailsAreRequired": "Se requieren detalles del cuidador",
    "centeneAttestationIss": "Certificación Centene (ISS)",
    "certificateOfCompletionOnlok": "Certificado de finalización (ONLOK)",
    "certificationIsRequired": "Se requiere certificación",
    "certifiedMechanicVerificatio": "VERIFICACIÓN MECÁNICA CERTIFICADA",
    "cf": "FQ:",
    "change": "Cambiar",
    "changePassword": "Cambiar contraseña",
    "checkin": "Registro",
    "checklist": "Lista de verificación",
    "checklistIsRequired": "Se requiere lista de verificación",
    "checklistNameIsRequired": "El nombre de la lista de verificación es obligatorio",
    "checkout": "Pagar",
    "city": "ciudad",
    "cityIsRequired": "Se requiere ciudad",
    "citystate": "Ciudad/Estado",
    "claim": "Reclamar",
    "claim2": "+ Reclamo",
    "claimIsRequired": "Se requiere reclamo",
    "claims": "Reclamaciones",
    "clear": "Borrar",
    "clearVehicle": "Borrar vehículo",
    "clientIdLabel": "ID de cliente/ID de miembro/MA#/AHCCCS#",
    "clientIdRequired": "Se requiere ID de cliente/ID de miembro/MA#/AHCCCS#",
    "clone": "clonar",
    "close": "Cerrar",
    "closePanel": "Cerrar panel",
    "closeSidebar": "Cerrar barra lateral",
    "closer": "Más cerca",
    "cms1500": "CMS 1500",
    "code": "Código",
    "codeIsRequired": "Se requiere código",
    "color": "Color",
    "colorIsRequired": "Se requiere color",
    "comment": "Comentario",
    "commentIsRequired": "Se requiere comentario",
    "comments": "Comentarios",
    "companiesStats": "Estadísticas de empresas",
    "company-img": "empresa-img",
    "companyAlias": "Alias de la empresa *",
    "companyBillingName": "Nombre de facturación de la empresa",
    "companyFaxNumber": "Número de fax de la empresa",
    "companyImage": "Imagen de la empresa",
    "companyImageIsRequired": "Se requiere imagen de la empresa",
    "companyInTake": "Empresa en adquisición (%)",
    "companyInTakeIs": "Se requiere participación de la empresa",
    "companyMobileNumber": "Número de móvil de la empresa",
    "companyMobileNumberIs": "Se requiere el número de móvil de la empresa",
    "companyName": "Nombre de la empresa",
    "companyNameIsRequired": "El nombre de la empresa es obligatorio",
    "companyNotes": "Notas de la empresa",
    "companyPhoto": "Foto de empresa",
    "competency": "competencia",
    "competencyIsRequired": "Se requiere competencia",
    "completed": "Completado",
    "completedFee": "Tarifa completada *",
    "completedTimeIsRequired": "Se requiere tiempo completado",
    "compliancePlanTrainingFraud": "Capacitación sobre el plan de cumplimiento (fraude, despilfarro y abuso) (Código de conducta)",
    "configurations": "Configuraciones",
    "confirm": "Confirmar",
    "confirmNewPassword": "Confirmar nueva contraseña",
    "confirmPassword": "Confirmar contraseña",
    "confirmPasswordDidtMatch": "Confirmar que la contraseña no coincide",
    "confirmPasswordIsRequired": "Confirmar Se requiere contraseña",
    "confirmationReport": "Informe de confirmación",
    "confirmationText": "Texto de confirmación",
    "confirmedLabel": "Confirmado",
    "contactNumber": "Número de contacto",
    "contactNumberIsRequired": "El número de contacto es obligatorio",
    "contractSent": "Contrato enviado",
    "corporate": "Corporativo",
    "corporateOdometerRequired": "Se requiere odómetro corporativo",
    "corporatePrivatePay": "Pago corporativo/privado",
    "costCenter": "Centro de costos",
    "costCenterIsRequired": "Se requiere centro de costos",
    "coverImage": "Imagen de portada",
    "covid": "Covid",
    "covid-19Vaccine": "Vacuna contra la COVID-19",
    "covid-19VaccineDeclined": "Vacuna contra el COVID-19 rechazada",
    "cprFirstAidCertification": "Fecha de inicio de la certificación de RCP/primeros auxilios (EXP)",
    "cprFirstAidCertification2": "Fecha de caducidad del certificado de RCP/primeros auxilios (EXP)",
    "createBucket": "Crear depósito",
    "createButton": "crear",
    "createSchedule": "Crear horario",
    "createTrip": "Crear viaje",
    "createTripsManually": "Crear viajes manualmente",
    "created": "Creado",
    "createdTimeIsRequired": "Se requiere tiempo de creación",
    "credentialInformation": "Información de credenciales",
    "credentialing": "Credencialización",
    "credentials": "Credenciales",
    "criminalBackgroundCheck": "Verificación de antecedentes penales",
    "criminalRecordAlcoholOr": "Antecedentes penales (abuso de alcohol o drogas)",
    "ctc": "CTC",
    "ctcBot": "BOT CTC",
    "ctcInvoice": "Factura CTC",
    "ctcMarketplace": "Mercado CTC",
    "ctcTrips": "Viajes CTC",
    "currentMeter": "Medidor de corriente",
    "currentMileageIsRequired": "Se requiere kilometraje actual",
    "currentPassword": "Contraseña actual",
    "currentPasswordIsRequired": "Se requiere contraseña actual",
    "custom": "personalizado",
    "daily": "Diariamente",
    "dashboard": "Panel de control",
    "date": "Fecha",
    "dateFormat": "Formato de fecha",
    "dateFormatIsRequired": "Se requiere formato de fecha",
    "dateIsRequired": "Se requiere fecha",
    "dateOfInspection": "Fecha de inspección",
    "dateOfInspectionIs": "Se requiere fecha de inspección",
    "dateOfService": "Fecha de servicio",
    "dateRange": "Rango de fechas *",
    "dayRequired": "Se requiere dia",
    "days": "dias",
    "days2": "Día(s)",
    "daysIsRequired": "Se requieren días",
    "ddmmyyyy": "DD/MM/AAAA",
    "deadMiles": "Millas muertas",
    "deadMilesRateIs": "Se requiere tarifa de millas muertas",
    "deadheadTimeToPickup": "Tiempo muerto (hasta la recogida)",
    "decline": "Rechazar",
    "defensiveDrivingCourse": "Curso de conducción defensiva",
    "delete": "Eliminar",
    "deleteAll": "Eliminar todo",
    "demo": "Demostración",
    "description": "Descripción",
    "descriptionIsRequired": "Se requiere descripción",
    "detail": "Detalle",
    "details": "Detalles",
    "diagnosismedicalCondition": "Diagnóstico/condición médica",
    "diagnosismedicalConditionIsR": "Se requiere diagnóstico/condición médica",
    "dimensions": "Dimensiones",
    "discount": "Descuento",
    "discountLabel": "Etiqueta de descuento",
    "dispatchMonthDay": "Envío Mes Día *",
    "dispatcher": "Despachador",
    "dispatcherNotesLabel": "Notas del despachador",
    "display": "Pantalla",
    "displayMode": "Modo de visualización",
    "displayNameLabel": "Nombre para mostrar",
    "displayNameRequired": "El nombre para mostrar es obligatorio",
    "displaySection": "Sección de visualización",
    "do": "DO",
    "doModifier": "Modificador HACER",
    "doModifierIsRequired": "Se requiere modificador DO",
    "doa": "DOA",
    "dobLabel": "Fecha de nacimiento",
    "dobRequired": "Se requiere fecha de nacimiento",
    "done": "hecho",
    "dos": "DOS:",
    "dot": "punto",
    "dotPhysicalExamAnnual": "Examen físico DOT (anual o previa solicitud)",
    "downBaseAddress": "Dirección de la base inferior",
    "download": "Descargar",
    "downloadCsv": "Descargar CSV",
    "downloadPdf": "Descargar PDF",
    "downloadPdfReport": "Descargar informe en PDF",
    "downloadReport": "Descargar Informe",
    "drawRoute": "Dibujar ruta",
    "driveDistance": "Distancia de conducción",
    "driver": "Conductor",
    "driver-score-chartsWorks": "¡Los gráficos de puntuación del conductor funcionan!",
    "driver2": "(Conductor)",
    "driverAddress": "Dirección del conductor",
    "driverAddressIsRequired": "Se requiere la dirección del conductor",
    "driverAlerts": "Alertas al conductor",
    "driverBreak": "Descanso del conductor",
    "driverBreakdown": "Avería del conductor",
    "driverImage": "Imagen del conductor",
    "driverInTake": "Conductor en toma (%)",
    "driverInTakeIs": "Se requiere conductor en toma",
    "driverInformation": "Información del conductor",
    "driverIsGettingLate": "El conductor se está retrasando",
    "driverIsIdle": "El conductor está inactivo (sin viajes)",
    "driverIsLate": "El conductor llega tarde",
    "driverIsOverloaded": "El conductor está sobrecargado (>12 viajes)",
    "driverLoad": "Carga del conductor",
    "driverName": "Nombre del conductor",
    "driverNotesLabel": "Notas del conductor",
    "driverOdometer": "Odómetro del conductor",
    "driverProfile": "Perfil del conductor",
    "driverRequired": "Se requiere conductor",
    "driverRoadTrainingEvidence": "Formación vial de conductores (evidencia)",
    "driverSched": "Programación del conductor",
    "driverShift": "Cambio de conductor",
    "driverShiftDayWise": "Turno del conductor (diurno)",
    "driverVerificationAlcohol": "Verificación del conductor (alcohol)",
    "driverVerificationDrug": "Verificación del conductor (drogas)",
    "driverdisplayname": "driver.displayName",
    "driversDrugTest": "Prueba de drogas para conductores",
    "drivingRecordMeetsRequiremen": "Registro de conducción (cumple con los requisitos)",
    "drop": "soltar",
    "dropoffAddress": "Dirección de entrega",
    "dropoffAddressIsRequired": "Se requiere dirección de entrega",
    "dropoffEarly": "Devolución temprana:",
    "dropoffHeader": "Devolución",
    "dropoffLate": "Entrega tardía:",
    "dropoffLateReason": "Motivo de entrega tardía:",
    "dropoffLateReason2": "Motivo de entrega tardía",
    "dropoffWise": "Devolución sabia",
    "dryRun": "Ejecución en seco",
    "dryRunCode": "Código de ejecución en seco",
    "dryRunCodeIs": "Se requiere código de ejecución en seco",
    "dsr": "DSR:",
    "dt": "DT",
    "dt2": "DT:",
    "dueDay": "Día de vencimiento *",
    "duplicate": "Duplicar",
    "durationIsRequired": "Se requiere duración.",
    "dvCompetencyAssessmentIss": "Evaluación de competencias DV (ISS)",
    "dvRequired": "DV requerido",
    "earlyActionActualVsScheduled": "Acción temprana (inicio real versus programado)",
    "earlyEta": "ETA temprana",
    "editNotes": "Editar notas",
    "editProfile": "Editar perfil",
    "editShift": "Editar turno",
    "editTripHeader": "Editar",
    "elderAbuseTraining": "Entrenamiento sobre abuso de personas mayores",
    "eligibility": "Elegibilidad",
    "eligibilityStatusIsRequired": "Se requiere estado de elegibilidad",
    "eligible": "Elegible",
    "email": "Correo electrónico:",
    "emailAddress": "Dirección de correo electrónico",
    "emailAddressIsRequired": "Se requiere dirección de correo electrónico",
    "emailConfiguration": "Configuración de correo electrónico",
    "emailIsNotValid": "El correo electrónico no es válido",
    "emailLabel": "Correo electrónico",
    "emailRequired": "Se requiere correo electrónico",
    "emergencyAndEvacuationTraini": "Entrenamiento de emergencia y evacuación",
    "employeeId": "ID de empleado",
    "employeeIdIsRequired": "Se requiere identificación de empleado",
    "employerNameIsRequired": "Se requiere el nombre del empleador",
    "employmentType": "Tipo de empleo",
    "employmentTypeIsRequired": "Se requiere tipo de empleo",
    "emtDriver": "Conductor paramédico",
    "emtLicense": "Licencia EMT",
    "emtLicenseImageIs": "Se requiere imagen de licencia EMT",
    "endDateLabel": "Fecha de finalización",
    "endDateRequired": "Se requiere fecha de finalización",
    "endOfShift": "Fin del turno",
    "endTime": "Hora de finalización",
    "endTimeIsRequired": "Se requiere hora de finalización",
    "ended": "(Terminado)",
    "endedAt": "Terminó en:",
    "englishLanguageLabel": "Inglés",
    "ensureThereAreNo": "⚠️Asegúrate de que no queden espacios alrededor del colon. Se requieren un mínimo de 3 caracteres para activar la búsqueda.",
    "enterTitle": "Ingrese el título",
    "enterYourEmail": "Introduce tu correo electrónico",
    "enterYourEmailAnd": "Ingrese su correo electrónico y seleccione la función para recibir el enlace de reinicio",
    "enterYourNewPassword": "Ingrese su nueva contraseña a continuación",
    "equipmentsAreRequired": "Se requieren equipos",
    "esf": "FSE:",
    "estimatedFareLabel": "Tarifa estimada",
    "estimatedFares": "Tarifas estimadas",
    "estimatedPickupTimeLabel": "Est. Poliuretano:",
    "every": "cada",
    "exiting": "Saliendo",
    "expandOnHover": "Expandir al pasar el cursor",
    "expectedAppointmentTimeLabel": "Hora prevista de la cita",
    "expectedAppointmentTimeMinError": "La hora prevista de la cita no puede ser anterior a la recogida (fecha y hora).",
    "expectedAppointmentTimeRequired": "Se requiere la hora prevista de la cita",
    "expenses": "Gastos",
    "expirationDate": "Fecha de vencimiento",
    "expirationDateIsRequired": "Se requiere fecha de vencimiento",
    "expired": "Caducado",
    "expiredTrips": "Viajes vencidos",
    "expiredTripsRoutes": "Rutas de viajes caducadas",
    "expiryDate": "Fecha de vencimiento",
    "expiryDateIsRequired": "Se requiere fecha de vencimiento",
    "exportCsv": "Exportar CSV",
    "extensiondispatcherNumber": "Número de extensión/despachador",
    "extensiondispatcherNumberIsR": "Se requiere número de extensión/despachador",
    "exteriorInformation": "Información exterior",
    "fare": "tarifa",
    "fareInformation": "Información de tarifas",
    "faxNumber": "Número de fax",
    "feedback": "Comentarios",
    "feet": "(pies)",
    "fetch": "buscar",
    "fetchEta": "Obtener ETA",
    "fetchTime": "Tiempo de recuperación",
    "file": "(Archivo)",
    "fileIsRequired": "el archivo es requerido",
    "fileName": "Nombre de archivo",
    "filter": "Filtrar",
    "fingerPrintLiveScan": "Escaneo en vivo de huellas dactilares",
    "finished": "Terminado",
    "finishedAndCancelled": "Terminado y cancelado",
    "finishedAt": "Terminado en:",
    "finishedCompleted": "Terminado / Completado",
    "finishedTimeIsRequired": "Se requiere hora de finalización",
    "finishedTrips": "Viajes terminados",
    "firstName": "Nombre",
    "firstNameIsRequired": "El nombre es obligatorio",
    "firstNameMustBe": "El nombre debe tener al menos 3 caracteres.",
    "fleet": "flota",
    "fleetInformation": "Información de flota",
    "fleetIsRequired": "Se requiere flota",
    "floorLabel": "piso",
    "floorRequired": "Se requiere piso",
    "florida": "florida",
    "flu": "gripe",
    "fluVaccine": "Vacuna contra la gripe",
    "fluVaccineDeclined": "Vacuna contra la gripe rechazada",
    "focalPerson": "Persona Focal",
    "focalPersonInformation": "Información de la persona focal",
    "for": "Para",
    "force": "fuerza",
    "forcedAcceptTrips": "Viajes de aceptación forzada",
    "forgotPassword": "Olvidé mi contraseña",
    "forgotPassword2": "¿Olvidaste tu contraseña?",
    "form837": "Modelo 837",
    "form837V2": "Formulario 837 v2",
    "freeQuota": "Cuota Gratuita",
    "from": "De",
    "fromIsRequired": "De es requerido",
    "fsIsRequired": "Se requiere FS",
    "fuelType": "Tipo de combustible",
    "fuelTypeIsRequired": "Se requiere tipo de combustible",
    "fullTime": "Tiempo completo",
    "fundingSourceAndValidity": "Se requieren fuente de financiamiento y rango de validez",
    "fundingSourceLabel": "Fuente de financiamiento",
    "noViolation": "Sin infracción",
    "fundingSourceRequired": "Se requiere fuente de financiamiento",
    "fundingSources": "Fuente(s) de financiamiento",
    "fundingSourcesAreRequired": "Se requieren fuentes de financiamiento",
    "garage": "Garaje",
    "garageAddress": "Dirección del garaje",
    "garageAddressIsRequired": "Se requiere la dirección del garaje",
    "gasCardNumber": "Número de tarjeta de gasolina",
    "gasCardNumberIs": "Se requiere el número de tarjeta de gasolina",
    "genderFemale": "Mujer",
    "genderLabel": "Género",
    "genderMale": "masculino",
    "genderOther": "Otro",
    "genderRequired": "Se requiere género",
    "general": "generales",
    "georgia": "georgia",
    "gisMiles": "Millas GIS",
    "goBackHome": "volver a casa",
    "googleMiles": "Millas de Google",
    "groundClearanceIsRequired": "Se requiere distancia al suelo",
    "groupByName": "Agrupar por nombre",
    "groupImageIsRequired": "Se requiere imagen de grupo",
    "groupName": "Nombre del grupo",
    "groupNameIsRequired": "El nombre del grupo es obligatorio",
    "groups": "Grupos",
    "gurneyTraining": "Entrenamiento en camilla",
    "handsFreeTraining": "Entrenamiento manos libres",
    "haversineMiles": "Millas Haversine",
    "height": "altura",
    "heightIsRequired": "Se requiere altura",
    "hepatitis": "hepatitis",
    "hhmm": "(HH:mm)",
    "hhmm2": "Mmmmm",
    "hhmm3": "HH:mm",
    "hideOneHourException": "Ocultar excepción de una hora",
    "hideThirdPartyDrivers": "Ocultar controladores de terceros",
    "hideUnassignedTrips": "Ocultar viajes no asignados",
    "hipaaPhiTrainingValid": "Capacitación HIPAA / PHI (Válido para siempre)",
    "history": "Historia",
    "holidayName": "Nombre de vacaciones",
    "holidayNameIsRequired": "El nombre del día festivo es obligatorio",
    "hoodInformation": "Información sobre el capó",
    "hospitalized": "hospitalizado",
    "host": "anfitrión",
    "howToUseThe": "🔍 Cómo utilizar la búsqueda",
    "iaal": "IAAL",
    "ifYouAlterThe": "Si altera la información de un viaje de manera que no coincida con los detalles del viaje real que tuvo lugar, está presentando una declaración falsa y cometiendo un delito. Cualquier persona que presente una declaración falsa será procesada con todo el peso de la ley.",
    "image": "imagen",
    "imageIsRequired": "Se requiere imagen",
    "img-corporate": "img-corporativo",
    "importFile": "Importar archivo",
    "importingTripsFromBrokers": "Importación de viajes de corredores",
    "inActiveReason": "En razón activa",
    "inActiveReasonIs": "En Razón Activa se requiere",
    "inMinutes": "(en minutos)",
    "inProgress": "En progreso",
    "inProgressTrips": "Viajes en progreso",
    "inProgressRoutes": "Rutas en progreso",
    "inReview": "En revisión",
    "inVehicle": "En vehículo",
    "inactive": "Inactivo",
    "incentive": "incentivo",
    "incentiveIsRequired": "Se requiere incentivo",
    "indiana": "Indiana",
    "ineligible": "No elegible",
    "info": "Información",
    "informDriver": "Informar al conductor",
    "information": "Información",
    "inspectionPassOrFail": "Se requiere inspección aprobada o reprobada",
    "interiorInformation": "Información interior",
    "invalidEmailFormat": "Formato de correo electrónico no válido",
    "invalidTrip": "Viaje no válido",
    "invoice": "factura",
    "invoices": "Facturas",
    "ipaLabel": "Número IPA/FECA",
    "ipaRequired": "Se requiere el número IPA / FECA",
    "ipcr": "IPCR",
    "isAcknowledgementOnFile": "¿Está el reconocimiento archivado?",
    "isCertificateOnFile": "¿Está el certificado archivado?",
    "isWave": "es onda",
    "issueDate": "Fecha de emisión",
    "issueDateIsRequired": "Se requiere fecha de emisión",
    "itineries": "Itinerarios",
    "kpisdriverdisplayname": "kpis.driver.displayName",
    "language": "Idioma",
    "lastInspectionDateIs": "Se requiere la última fecha de inspección",
    "lastName": "Apellido",
    "lastNameIsRequired": "El apellido es obligatorio",
    "lastNameMustBe": "El apellido debe tener al menos 3 caracteres.",
    "lateCushion": "Cojín tardío",
    "lateCushionIsRequired": "Se requiere cojín tardío",
    "lateEta": "ETA tardía",
    "lbs": "(libras)",
    "legCancellationAlert": "Alerta de cancelación de tramo",
    "legLabel": "pierna-",
    "legalInformation": "Información Legal",
    "legalName": "Nombre Legal",
    "legalNameIsRequired": "Se requiere nombre legal",
    "legalNameMustBe": "El nombre legal debe tener al menos 3 caracteres.",
    "lengthIsRequired": "Se requiere longitud",
    "lengthMustBe3": "La longitud debe ser 3.",
    "levelOfServiceImage": "imagen de nivel de servicio",
    "levelOfServiceLabel": "Nivel de servicio",
    "levelOfServiceRequired": "Se requiere nivel de servicio",
    "levelofservice-image": "imagen de nivel de servicio",
    "licenseInformation": "Información de licencia",
    "licenseNumber": "Número de licencia",
    "licenseNumberIsRequired": "Se requiere número de licencia",
    "licensePlate": "Matrícula",
    "licensePlateInformation": "Información de la matrícula",
    "licensePlateIsRequired": "Se requiere matrícula",
    "lightsInformation": "Información de luces",
    "limitation": "Limitación",
    "limitations": "Limitaciones",
    "line": "Línea",
    "list": "Lista",
    "listView": "Vista de lista",
    "livescanDojFbi": "LIVESCAN (DOJ + FBI)",
    "livescanDojOnly": "LIVESCAN (solo Departamento de Justicia)",
    "load": "Cargar",
    "loadTimeIsRequired": "Se requiere tiempo de carga",
    "loadedMilesRateIs": "Se requiere tarifa de millas cargadas",
    "loadedTime": "Tiempo cargado",
    "loadedTimeToDropoff": "Tiempo cargado (hasta la entrega)",
    "loginInformation": "INFORMACIÓN DE INICIO DE SESIÓN",
    "logisticareTemplate": "Plantilla LogisticCare",
    "logo": "logotipo",
    "logout": "Cerrar sesión",
    "logs": "Registros",
    "los": "LOS:",
    "losAndSpaceType": "Se requiere Los y el tipo de espacio",
    "lt": "LT",
    "lt2": "LT:",
    "lunch": "Almuerzo",
    "maintenanceInformation": "Información de mantenimiento",
    "maintenances": "Mantenimientos",
    "makeItLive": "Hazlo vivir",
    "makeModel": "Marca y modelo",
    "makeModelIsRequired": "Se requiere marca y modelo",
    "mandatoryForCms1500": "(Obligatorio para el formulario CMS 1500)",
    "mandatoryForMedicaidAnd": "(Obligatorio para los formularios Medicaid y CMS 1500)",
    "mandatoryForMedicaidAuth": "(Obligatorio para el formulario de autenticación de Medicaid)",
    "manifest": "Manifiesto",
    "manifestLegend": "Leyenda manifiesta",
    "manual": "manuales",
    "manualGenerate": "Generación manual",
    "manualTrip": "Viaje manual",
    "mapperIsRequired": "Se requiere mapeador",
    "markComplete": "Marcar completo",
    "markMemberReady": "Marcar miembro listo",
    "markedReady": "Marcado listo",
    "markedReadyRoutes": "Rutas listas y marcadas",
    "markedReadyTrips": "Viajes listos marcados",
    "marketplace": "Mercado",
    "maxDistance": "Distancia máxima:",
    "maxOnboardTime": "Tiempo máximo a bordo:",
    "maxTrips": "Viajes máximos:",
    "meal": "comida",
    "mealBreak": "Pausa para comer",
    "mechanicverificationsignatur": "mecánicoVerificación.firma",
    "medex": "MEDEX",
    "medical": "medico",
    "medicalIdIsRequired": "Se requiere identificación médica",
    "medicalLogo": "Logotipo médico",
    "medicalTrip": "Viaje médico",
    "member-image": "imagen-miembro",
    "memberLabel": "Miembro",
    "memberLoading": "Cargando miembros",
    "memberName": "Nombre de miembro",
    "memberNotVisible": "Miembro no visible",
    "memberOnboard": "Miembro a bordo",
    "memberOnboardAt": "Miembro a bordo en:",
    "memberRequired": "Se requiere miembro",
    "memberRoleIsRequired": "Se requiere rol de miembro",
    "memberStatus": "Estado de miembro",
    "memberType": "Tipo de miembro",
    "memberTypeIsRequired": "El tipo de miembro es obligatorio",
    "memberdisplayname": "miembro.nombredevisualización",
    "membersPhoneNumber": "Número de teléfono del miembro",
    "merge": "fusionar",
    "messageAlerts": "Alertas de mensajes",
    "messages": "Mensajes",
    "methadone": "metadona",
    "method": "Método",
    "methodIsRequired": "Se requiere método",
    "mfa": "(MFA)",
    "mfb": "mfb",
    "mi": "mi",
    "mid": "medio",
    "middleName": "Segundo nombre",
    "middleNameIsRequired": "Se requiere segundo nombre",
    "mile": "Milla",
    "miles": "millas",
    "milesForBucksDriver": "Conductor de millas por dólares",
    "milesForBucksPanel": "Panel de Millas por Dólares",
    "milesLabel": "Millas",
    "milesRequired": "Se requieren millas",
    "minimum3CharactersRequired": "Se requieren mínimo 3 caracteres",
    "minimum5CharactersRequired": "Se requieren un mínimo de 5 caracteres",
    "mins": "Minutos",
    "minutes": "minutos",
    "minutesIsRequired": "Se requieren minutos",
    "mm": "(mm)",
    "mmddyyyy": "DD/MM/AAAA",
    "mobileNumberLabel": "Número de móvil",
    "mobileNumberRequired": "Se requiere número de móvil",
    "model": "modelo",
    "modelIsRequired": "Se requiere modelo",
    "modifierLabel": "Modificador",
    "modifierRequired": "Se requiere modificador",
    "moicu": "MoICU",
    "moreFeaturesComingSoon": "📝 Más funciones próximamente",
    "moreLabel": "más...",
    "na": "N/A",
    "name": "Nombre",
    "nameIsRequired": "El nombre es obligatorio",
    "nemt": "NEMT",
    "nemtStatistics": "Estadísticas del NEMT",
    "newExpense": "Nuevo Gasto",
    "newInspection": "Nueva inspección",
    "newPassword": "Nueva contraseña",
    "newPasswordIsRequired": "Se requiere nueva contraseña",
    "no": "No",
    "noAgentTripsTo": "No hay viajes de agentes para mostrar",
    "noAnswer": "Sin respuesta",
    "noCompanyDetailsTo": "No hay detalles de la empresa para mostrar",
    "noCtcTripTo": "No hay viaje de CTC para mostrar",
    "noDataToShow": "No hay datos para mostrar",
    "noDetailsToShow": "No hay detalles que mostrar",
    "noDirtRoadTrips": "No hay viajes por caminos de tierra para mostrar",
    "noDriverDetailsTo": "No hay detalles del conductor para mostrar",
    "noEarning": "Sin ganancias",
    "noEarningsToShow": "No hay ganancias que mostrar",
    "noMessageToShow": "No hay mensaje para mostrar",
    "noNotificationsToShow": "No hay notificaciones para mostrar",
    "noOfEscortsLabel": "No. de acompañantes",
    "noOfEscortsRequired": "Se requiere No. de Escorts",
    "noOfRoutes": "No. de Rutas",
    "noOfRoutesAre": "No. de rutas son requeridas",
    "noOfSeats": "No. de asientos",
    "noOfSeatsAre": "Se requiere número de asientos",
    "noParsedFileFound": "No se encontró ningún archivo analizado",
    "noRecords": "Sin registros",
    "noShowCharges": "Cargos por no presentarse",
    "noShowChargesIs": "Se requieren cargos por no presentarse",
    "noStatisticsToShow": "No hay estadísticas para mostrar",
    "noTripLogsTo": "No hay registros de viaje para mostrar",
    "noTripsAssign": "No hay viajes asignados",
    "noTripsToShow": "No hay viajes para mostrar",
    "noUnassignedTrips": "No hay viajes no asignados",
    "non-transportVehicle": "Vehículo que no es de transporte",
    "none": "Ninguno",
    "notAvailable": "No disponible",
    "notEligible": "No elegible",
    "note": "Nota",
    "notes": "Notas",
    "notesAreRequired": "Se requieren notas",
    "notificationMethod": "Método de notificación",
    "notifications": "Notificaciones",
    "odometer": "Odómetro",
    "odometerBegin": "Inicio del odómetro",
    "odometerBeginIsRequired": "Se requiere inicio del odómetro",
    "odometerBeginReadingIs": "Se requiere comenzar a leer el odómetro",
    "odometerEndIsRequired": "Se requiere el extremo del odómetro",
    "odometerRequired": "Se requiere odómetro",
    "odometerStart": "Inicio del odómetro",
    "odometerStartIsRequired": "Se requiere inicio del odómetro",
    "odometerStop": "Parada del odómetro",
    "odometerStopIsRequired": "Se requiere parada del odómetro",
    "of": "de",
    "offeredAccepted": "Ofrecido/Aceptado",
    "offeredTrips": "Viajes ofrecidos",
    "offline": "Sin conexión",
    "oigScreening": "Evaluación de la OIG",
    "onScene": "En escena:",
    "onScene2": "En escena",
    "onSceneReport": "Informe en escena",
    "onWay": "En camino",
    "onWayAt": "En camino a:",
    "onboard": "A bordo",
    "oneHourException": "Excepción de 1 hora",
    "onq": "ONQ",
    "onscene": "En escena",
    "onsceneTimeIsRequired": "Se requiere tiempo en la escena",
    "onway": "En camino",
    "open": "Abierto",
    "openMainMenu": "Abrir menú principal",
    "openUserMenu": "Abrir menú de usuario",
    "opener": "Abridor",
    "operations": "Operaciones",
    "operationsManager": "Gerente de Operaciones",
    "operationsManagerIsRequired": "Se requiere gerente de operaciones",
    "optIn": "OPTAR EN",
    "orDragAndDrop": "o arrastrar y soltar",
    "ordAct": "Orden/Ley",
    "order": "Orden",
    "orderIsRequired": "Se requiere orden",
    "organizationId": "ID de organización",
    "organizationIdIsRequired": "Se requiere ID de organización",
    "otherInformation": "Otra información",
    "otherLegsHeader": "Otras piernas",
    "others": "Otros",
    "otp": "OTP",
    "outsideShift": "turno exterior",
    "outstandingTrips": "Viajes destacados",
    "ownerDetails": "Detalles del propietario",
    "pageNotFound": "Página no encontrada",
    "paid": "Pagado",
    "panel": "panel",
    "parseTrips": "Analizar viajes",
    "partTime": "Tiempo parcial",
    "partner": "Socio",
    "passenger": "Pasajero",
    "passengerAssistanceAndCultur": "Asistencia al Pasajero y Formación Cultural (EXP)",
    "passengerInformation": "Información del pasajero",
    "password": "Contraseña",
    "passwordInformation": "Información de contraseña",
    "passwordIsRequired": "Se requiere contraseña",
    "passwordMustBeAtleast": "La contraseña debe tener al menos 6 caracteres.",
    "passwordMustBeAtleast2": "La contraseña debe tener al menos 6 caracteres.",
    "passwordMustBeMaximum": "La contraseña debe tener un máximo de 16 caracteres.",
    "passwordMustBeMaximum2": "La contraseña debe tener un máximo de 16 caracteres.",
    "patient": "Paciente",
    "paymentConfirmed": "Pago confirmado",
    "paymentUnconfirmed": "Pago no confirmado",
    "payorLabel": "pagador",
    "pending": "Pendiente",
    "pendingFee": "Tarifa pendiente *",
    "perMile": "Por milla",
    "perMileCode": "Código por milla",
    "perMileCodeIs": "Se requiere código por milla",
    "perMileIsRequired": "Se requiere por milla",
    "perMinIsRequired": "Se requiere por minuto",
    "perMinute": "Por minuto",
    "period": "Periodo",
    "permissions": "Permisos",
    "person": "persona",
    "phoneNumberLabel": "Número de teléfono",
    "phoneNumberRequired": "Se requiere número de teléfono",
    "pickupAddress": "Dirección de recogida",
    "pickupAddressIsRequired": "Se requiere dirección de recogida",
    "pickupEarly": "Recogida anticipada:",
    "pickupHeader": "Recogida",
    "pickupLate": "Recoger tarde:",
    "pickupLateReason": "Motivo de recogida tardía",
    "pickupLateReasons": "Motivos de recogida tardía:",
    "pickupTme": "Hora de recogida",
    "pickupWise": "Recogida sabia",
    "placeNameLabel": "Nombre de casa/instalación",
    "placeNameRequired": "El nombre de la casa/instalación es obligatorio",
    "planner": "Planificador",
    "platform": "Plataforma",
    "platformIsRequired": "Se requiere plataforma",
    "platformportal": "Plataforma/Portal",
    "platformportalIsRequired": "Se requiere plataforma/portal",
    "pleaseChooseAnyAbove": "Por favor elija cualquier motivo anterior",
    "pleaseEnterDispatcherNotes": "Por favor ingrese las notas del despachador",
    "pleaseEnterForDriver": "Por favor ingrese Para notas del conductor",
    "pleaseEnterTheClient": "Por favor ingrese el nombre del cliente",
    "pleaseEnterTheDate": "Ingrese la fecha de verificación del registro del vehículo motorizado del conductor.",
    "pleaseEnterTheDescription": "Por favor ingresa la descripción",
    "pleaseEnterTheNote": "Por favor ingrese la nota",
    "pleaseEnterTheNotes": "Por favor ingrese las Notas",
    "pleaseEnterThePrivate": "Por favor ingrese la nota privada",
    "pleaseEnterTheTime": "Por favor ingresa la zona horaria",
    "pleaseNoteByUsing": "Tenga en cuenta que al utilizar esta función debe omitir cualquier viaje que no se haya realizado en tierra para que no se fabrique información en el sistema.",
    "pleaseSelectAtLeast": "Seleccione al menos un controlador.",
    "pleaseSelectCompanyTo": "Por favor seleccione la empresa para mostrar el registro",
    "pleaseSelectPrimaryMember": "Por favor seleccione miembro principal",
    "pleaseSelectTimeIn": "Por favor seleccione la hora en",
    "pleaseTakeNoticeFiling": "TENGA EN CUENTA: PRESENTAR DECLARACIONES FALSAS ES UN DELITO",
    "pngJpgGifUp": "PNG, JPG, GIF hasta 10MB",
    "policeClearance": "Autorización policial",
    "port": "puerto",
    "portIsRequired": "Se requiere puerto",
    "position": "Posición",
    "positionIsRequired": "Se requiere posición",
    "possibilityButton": "Posibilidad",
    "primary": "Primaria",
    "primaryDiagnoseLabel": "Diagnóstico primario",
    "primaryDiagnoseRequired": "Se requiere diagnóstico primario",
    "priority": "Prioridad",
    "priorityIsRequired": "Se requiere prioridad",
    "privateLabel": "(Privado)",
    "privateNote": "Nota privada",
    "proceed": "Continuar",
    "proficiency": "competencia",
    "proficiencyIsRequired": "Se requiere competencia",
    "profile": "Perfil",
    "profileImage": "Imagen de perfil",
    "profileImageIsRequired": "Se requiere imagen de perfil",
    "profileInformation": "Información de perfil",
    "profileOverview": "Descripción general del perfil",
    "profileimage": "imagen_perfil",
    "protips": "Consejos profesionales",
    "proposedReadyTime": "Tiempo de preparación propuesto",
    "pu": "PU",
    "puModifier": "Modificador de PU",
    "puModifierIsRequired": "Se requiere modificador PU",
    "pua": "PUA",
    "publicLabel": "(Público)",
    "pull-Out": "EXTRAER - FUERA",
    "pullEnd": "TIRAR / FINALIZAR",
    "put": "PUT",
    "quantityLabel": "Cantidad",
    "quantityRequired": "Se requiere cantidad",
    "quarterdisplayname": "quarter.displayName",
    "quickFilter": "Filtro rápido",
    "quickSearch": "búsqueda rápida",
    "quickSearchGuide": "🔍 Guía de búsqueda rápida",
    "radiusIsRequired": "Se requiere radio",
    "rates": "Tarifas",
    "rawReport": "Informe sin procesar",
    "re-assign": "Reasignar",
    "readyNotes": "Notas listas",
    "reason": "Razón",
    "reasonIsRequired": "Se requiere la razón",
    "recurringDays": "Días recurrentes",
    "recurringStatusRequired": "Se requiere estado recurrente",
    "refS": "Números de referencia",
    "reference": "Referencia",
    "reg": "Registro:",
    "regular": "regular",
    "reject": "Rechazar",
    "rejected": "Rechazado",
    "rejectedTrips": "Viajes rechazados",
    "relation": "Relación",
    "relationIsRequired": "Se requiere relación",
    "removeButton": "Quitar",
    "reply": "Responder",
    "reports": "Informes",
    "representativesignature": "firma.del.representante",
    "requiredOdometers": "Odómetros requeridos",
    "rescheduleTrip": "Reprogramar viaje",
    "resendCode": "¿Reenviar código?",
    "reservationNo": "Número de reserva:",
    "reset": "Reiniciar",
    "resetPassword": "Restablecer contraseña",
    "responseNightCode": "Código nocturno de respuesta",
    "responseNightCodeIs": "Se requiere código de noche de respuesta",
    "rest": "Descanso",
    "restBreak": "Descanso",
    "return": "Regresar",
    "revenue": "Ingresos",
    "reviewUrl": "URL de revisión",
    "rfLfRrLr": "(RF LF RR LR)",
    "rigNo": "Equipo No.",
    "rigNoIsRequired": "Se requiere el número de plataforma",
    "ripplingId": "Identificación ondulante",
    "ripplingIdIsRequired": "Se requiere identificación ondulada",
    "rode": "montó",
    "roleIsRequired": "Se requiere rol",
    "roleType": "Tipo de rol",
    "roleTypeIsRequired": "El tipo de rol es obligatorio",
    "roomLabel": "Habitación",
    "roomRequired": "Se requiere espacio",
    "routeDetails": "Detalles de la ruta",
    "routeView": "Vista de ruta",
    "samScreening": "Detección SAM",
    "save": "Guardar",
    "saveForAll": "Ahorre para todos",
    "saveTemplate": "Guardar plantilla",
    "scheduleShells": "Programar Shell(es)",
    "scheduleShellsIsRequired": "Se requiere programar Shell(s)",
    "scheduleTime": "Horario de programación",
    "scheduleTimeIsRequired": "Horario Se requiere tiempo",
    "scheduledTrips": "Viajes programados",
    "score": "Puntuación",
    "scoreDetails": "Detalles de la puntuación",
    "search": "Buscar",
    "search2": "Buscar...",
    "searchCompany": "Buscar empresa",
    "searchDriver": "Buscar controlador",
    "searchGroup": "Grupo de búsqueda",
    "searchMessages": "Buscar mensajes",
    "searchVehicle": "Buscar vehículo",
    "seconds": "(segundos)",
    "secureComplianceTrainingAckn": "Reconocimiento de capacitación en cumplimiento seguro",
    "secureType": "Tipo seguro",
    "seeAll": "Ver todo",
    "seenBy": "Visto por",
    "selectAddonItemPlaceholder": "-- Seleccionar artículo --",
    "selectAll": "Seleccionar todo",
    "selectAppointmentDirectionPlaceholder": "-- Seleccionar dirección de cita --",
    "selectAppointmentTypePlaceholder": "-- Seleccione el tipo de cita --",
    "selectAssistsPlaceholder": "- Seleccionar asistencias -",
    "selectBreak": "Seleccionar descanso",
    "selectCorporate": "Seleccione Corporativo",
    "selectDate": "Seleccionar fecha",
    "selectDateRange": "Seleccionar rango de fechas",
    "selectDos": "Seleccione DOS",
    "selectDriver": "Seleccionar controlador",
    "selectDriverPlaceholder": "-- Seleccionar controlador --",
    "selectFundingSource": "Seleccionar fuente de financiamiento",
    "selectFundingSourcePlaceholder": "-- Seleccionar fuente de financiamiento --",
    "selectGenderPlaceholder": "-- Seleccione Género --",
    "selectLevelOfService": "Seleccione el nivel de servicio",
    "selectLevelOfServicePlaceholder": "-- Seleccionar nivel de servicio --",
    "selectMember": "Seleccionar miembro",
    "selectMemberPlaceholder": "-- Seleccionar Miembro --",
    "selectModifierPlaceholder": "-- Seleccione Modificador --",
    "selectNoOfEscortsPlaceholder": "-- Seleccione No. De Acompañante --",
    "selectPayorPlaceholder": "-- Seleccionar Pagador --",
    "selectPrimaryDiagnosePlaceholder": "-- Seleccione Diagnóstico primario --",
    "selectServiceArea": "Seleccionar área de servicio",
    "selectServiceAreaPlaceholder": "-- Seleccionar Área de Servicio --",
    "selectSpaceType": "Seleccione tipo de espacio",
    "selectSpaceTypePlaceholder": "-- Seleccionar tipo de espacio --",
    "selectStatus": "Seleccionar estado",
    "selectTime": "Seleccionar hora",
    "selectTimezone": "Seleccionar zona horaria",
    "selectType": "Seleccionar tipo",
    "selectedDriverIsRequired": "Se requiere el controlador seleccionado",
    "selectedServiceAreaIs": "Se requiere el área de servicio seleccionada",
    "selectedTrip": "Viaje seleccionado",
    "send": "enviar",
    "sendCode": "Enviar código",
    "sendEmail": "Enviar correo electrónico",
    "sendOnBreak": "Enviar en vacaciones",
    "sentYouAnInvite": "Te envié una invitación para conectarte.",
    "serviceAreaLabel": "Área de servicio",
    "serviceAreaRequired": "Se requiere área de servicio",
    "serviceAreas": "Área(s) de servicio",
    "serviceAreasIsRequired": "Se requieren áreas de servicio",
    "serviceNameIsRequired": "El nombre del servicio es obligatorio.",
    "serviceRepresentative": "REPRESENTANTE DE SERVICIO",
    "services": "Servicios",
    "setBsr": "Establecer BSR",
    "setTags": "Establecer etiquetas",
    "setiD": "Seti D:",
    "settings": "Configuración",
    "sexOffenderBackgroundCheck": "Verificación de antecedentes de delincuentes sexuales",
    "sexualHarassmentTraining": "Capacitación sobre acoso sexual",
    "shift": "Turno:",
    "shift-End": "MAYÚS - FIN",
    "shiftAlign": "Alinear turnos",
    "shiftAlignIsRequired": "Se requiere alineación de turnos",
    "shiftDayWise": "Turno (día sabio)",
    "shiftEnd": "Fin del turno",
    "shiftEndIsRequired": "Se requiere fin de turno",
    "shiftMarker": "Marcador de cambio",
    "shiftOverride": "Anulación de turno",
    "shiftOverrideNotAvailable": "Anulación de turno (no disponible)",
    "shiftStart": "Inicio de turno",
    "shiftStartIsRequired": "Se requiere inicio de turno",
    "shifts": "Turnos",
    "showBreak": "Mostrar pausa",
    "showGoogleMiles": "Mostrar millas de Google",
    "showRoute": "Mostrar ruta",
    "showUnassignedTrips": "Mostrar viajes no asignados",
    "signIn": "Iniciar sesión",
    "signInToYour": "Inicia sesión en tu cuenta",
    "signature": "Firma",
    "signatureIsRequired": "Se requiere firma",
    "single": "soltero",
    "skipSignature": "Saltar firma",
    "smokeFreeVehiclesDriver": "Vehículos libres de humo (comprensión del conductor)",
    "sms": "SMS",
    "sms/dashboard": "SMS/Panel",
    "smsRequired": "Se requiere SMS",
    "sorryWeCouldntFind": "Lo sentimos, no pudimos encontrar la página que estás buscando.",
    "sort": "ordenar",
    "spaceTypeLabel": "Tipo de espacio",
    "spaceTypeRequired": "Se requiere tipo de espacio",
    "spaceTypefileIsRequired": "Se requiere tipo de espacio (archivo)",
    "spaceTypesIsRequired": "Se requieren tipos de espacio",
    "spacetypeImage": "Imagen de tipo espacial",
    "spacetypeIsRequired": "Se requiere tipo de espacio",
    "spacetypes": "Tipos de espacio",
    "specialFare": "Tarifa especial",
    "specialRequests": "Solicitudes especiales",
    "squareImageIsRecommended": "*Se recomienda imagen cuadrada",
    "ssl": "SSL",
    "staff": "(Personal)",
    "stagingTrips": "Viajes de puesta en escena",
    "stairsSteps": "Escalón/es de escalera",
    "stairsStepsIsRequired": "Se requieren escalones de escalera",
    "standingOrderHeader": "Orden permanente",
    "startDate": "Fecha de inicio",
    "startDateIsRequired": "Se requiere fecha de inicio",
    "startTime": "Hora de inicio",
    "startTimeIsRequired": "Se requiere hora de inicio",
    "started": "iniciado",
    "startedAt": "Comenzó en:",
    "startedTimeIsRequired": "Se requiere hora de inicio",
    "statReport": "Informe de estadísticas",
    "stateCode": "Código estatal",
    "stateCodeIsRequired": "Se requiere código estatal",
    "stateIsRequired": "Se requiere estado",
    "statistics": "Estadísticas",
    "statusActive": "Activo",
    "statusInactive": "En activo",
    "statusIsRequired": "Se requiere estado",
    "statusLabel": "Estado",
    "statuses": "Estados",
    "statuss": "Estado(s)",
    "stop": "Detener",
    "stopTimeIsRequired": "Se requiere tiempo de parada",
    "storageInformation": "Información de almacenamiento",
    "submit": "Enviar",
    "suggestTime": "Sugerir hora",
    "suggestedTime": "Hora sugerida",
    "support": "Soporte",
    "svc": "Servicio",
    "sweep": "barrer",
    "sweepFile": "Archivo de barrido",
    "table": "mesa",
    "table-user": "usuario de mesa",
    "takeSignature": "Tomar firma",
    "taxInformation": "Información fiscal",
    "taxonomyCode": "Código de taxonomía",
    "tbTest": "Prueba de tuberculosis",
    "template": "Plantilla",
    "templateIsRequired": "Se requiere plantilla",
    "textAssistanceRequiredFor": "Se requiere asistencia por mensaje de texto para el miembro.",
    "textLiveLinkTo": "Enlace en vivo por mensaje de texto al miembro",
    "thirdParty": "Tercero",
    "thisOperationWillComplete": "Esta operación completará la información necesaria para generar archivos de reclamaciones de seguros, como registros de viajes, formularios TRF, etc.",
    "threshold": "umbral",
    "thresholdIsRequired": "Se requiere umbral",
    "timeCalibration": "Calibración de tiempo",
    "timeFormat": "Formato de hora",
    "timeFormatIsRequired": "Se requiere formato de hora",
    "timeIn": "Tiempo en",
    "timeInAt": "Hora en",
    "timeInIsRequired": "Se requiere tiempo de entrada",
    "timeLabel": "tiempo",
    "timeOut": "Tiempo muerto",
    "timeOutIsRequired": "Se requiere tiempo de espera",
    "timeRequired": "Se requiere tiempo",
    "timeZone": "Zona horaria",
    "timeZoneIsRequired": "Se requiere zona horaria",
    "timein": "tiempo en",
    "timeline": "Línea de tiempo",
    "timelines": "Líneas de tiempo",
    "times": "&veces;",
    "tipStatusIsRequired": "El estado de la propina es obligatorio",
    "tipTitleIsRequired": "El título del consejo es obligatorio",
    "tiresInformation": "Información sobre neumáticos",
    "title": "Título",
    "titleIsRequired": "Se requiere título",
    "tls": "tls",
    "to": "a",
    "toIsRequired": "Se requiere",
    "today": "hoy",
    "toll-freeNumber": "Número gratuito",
    "toll-freeNumberIsRequired": "Se requiere un número gratuito",
    "totalFare": "Tarifa total",
    "totalFareIsRequired": "Se requiere tarifa total",
    "tp": "(TP)",
    "traffic": "Tráfico",
    "travelAndSequence": "Viaje y secuencia",
    "trial": "juicio",
    "trialEnd": "Fin del juicio",
    "tripAssistance": "Asistencia en viaje",
    "tripId": "ID de viaje",
    "tripIdLabel": "ID de viaje",
    "tripIdRequired": "Se requiere identificación de viaje",
    "tripInformation": "Información de viaje",
    "tripLogs": "Registros de viaje",
    "tripQuota": "Cuota de viaje",
    "tripQuotaIsRequired": "Se requiere cuota de viaje",
    "tripReport": "Informe de viaje",
    "tripRoute": "Ruta de viaje",
    "tripS": "viaje(s)",
    "tripSequenceLate": "Secuencia de viaje (tarde)",
    "tripSequenceOnTime": "Secuencia de viaje (a tiempo)",
    "tripStatus": "Estado del viaje",
    "tripWise": "Viaje sabio",
    "trips": "Viajes",
    "tripsAdjustmentImportant": "Ajuste de viajes (Importante antes de realizar operaciones bancarias)",
    "tripsFile": "Archivo de viajes",
    "tripsFileIsRequired": "Se requiere archivo de viajes",
    "tripsItinerary": "Itinerario de viajes",
    "tripsMapDashboard": "Panel de control del mapa de viajes",
    "type": "Tipo",
    "typeAMessage": "Escribe un mensaje.....",
    "un-selectAll": "Deseleccionar todo",
    "unassign": "Desasignar",
    "unassigned": "No asignado",
    "unassignedCancelled": "Cancelado no asignado",
    "unassignedTrips": "Viajes no asignados",
    "unconfirm": "Desconfirmar",
    "undo": "Deshacer",
    "unknown": "Desconocido",
    "unloadTimeIsRequired": "Se requiere tiempo de descarga",
    "unscheduled": "[No programado]",
    "upBaseAddress": "Dirección base arriba",
    "updateAssists": "Asistencia de actualización",
    "updateButton": "Actualizar",
    "updateStatus": "Estado de actualización",
    "uploadAFile": "Subir un archivo",
    "uploadAnImage": "Sube una imagen",
    "uploadJpegJpgOr": "Sube un archivo .jpeg, .jpg o .png",
    "uploadTxtFile": "Subir archivo .txt",
    "uploadXlsxXlsOr": "Sube un archivo .xlsx, .xls o .csv",
    "urduLanguageLabel": "Urdu",
    "url": "URL",
    "useAPermanentAddress": "Utilice una dirección permanente donde pueda recibir correo.",
    "useAuthenticSignatures": "Utilice firmas auténticas.",
    "useMemberPermanentAddress": "Utilice la dirección permanente del miembro donde pueda recibir correo.",
    "useSettingAriaLabel": "Usar configuración",
    "user": "usuario",
    "user-image": "imagen de usuario",
    "user-img": "img de usuario",
    "userPhoto": "foto de usuario",
    "username": "Nombre de usuario",
    "usernameIsRequired": "El nombre de usuario es obligatorio",
    "users": "Usuarios",
    "usingTheBelowForm": "Usando el siguiente formulario para agregar una nueva configuración de corredor",
    "usingTheBelowForm2": "Usando el siguiente formulario para agregar una nueva configuración de correo electrónico",
    "v1": "V1",
    "v2": "V2",
    "v3": "V3",
    "validityRange": "Rango de validez",
    "validityRangeIsRequired": "Se requiere rango de validez",
    "vehicle": "Vehículo",
    "vehicleDecalNumberIs": "Se requiere el número de calcomanía del vehículo",
    "vehicleGarage": "Garaje de vehículos",
    "vehicleIdentificationNumberI": "Se requiere el número de identificación del vehículo",
    "vehicleImageBack": "Imagen del vehículo Atrás",
    "vehicleImageFront": "Imagen del vehículo frontal",
    "vehicleImageLeft": "Imagen del vehículo a la izquierda",
    "vehicleImageRight": "Imagen del vehículo a la derecha",
    "vehicleInspectionInPast": "Inspección del vehículo en los últimos 12 meses con período retrospectivo.",
    "vehicleMakeIsRequired": "Se requiere marca del vehículo",
    "vehicleRecordCheckDot": "Verificación de registro del vehículo (DOT MVR)",
    "vehicleRecordCheckStandard": "Verificación del registro del vehículo (verificación estándar)",
    "vehicleServiceNumberIs": "Se requiere el número de servicio del vehículo",
    "vehicleTypeIsRequired": "Se requiere tipo de vehículo",
    "vehicleWise": "En cuanto al vehículo",
    "vehiclesFleet": "Vehículos/Flota",
    "verifyCode": "Verificar código",
    "viewRoute": "Ver ruta",
    "viewTripsOnly": "Ver solo viajes",
    "vin": "Número de bastidor",
    "vinIsRequired": "Se requiere VIN",
    "violationIsRequired": "Se requiere violación",
    "violationSets": "Conjuntos de violaciones",
    "vipExpiryDate": "Fecha de vencimiento VIP",
    "vipExpiryDateIs": "Se requiere fecha de vencimiento VIP",
    "vipLabel": "vip",
    "vipMembers": "Miembros VIP",
    "virginia": "Virginia",
    "visit": "Visita",
    "voicemail": "Correo de voz",
    "waitTime": "Tiempo de espera",
    "waitTimeCode": "Código de tiempo de espera",
    "waitTimeCodeIs": "Se requiere código de tiempo de espera",
    "waitTimeIsRequired": "Se requiere tiempo de espera",
    "wandererRisk": "Riesgo de vagabundo",
    "warning": "Advertencia",
    "weekendNightCode": "Código de noche de fin de semana",
    "weekendNightCodeIs": "Se requiere código de noche de fin de semana",
    "weeklyFee": "Tarifa semanal",
    "weeklyFeeIsRequired": "Se requiere tarifa semanal",
    "weightLabel": "Peso",
    "weightRequired": "Se requiere peso",
    "wheelchairRampInformation": "Información sobre rampas para sillas de ruedas",
    "wheelchairSecurementTraining": "Capacitación sobre sujeción de sillas de ruedas (EXP)",
    "widthIsRequired": "Se requiere ancho",
    "willCall": "llamará",
    "willCall2359": "Llamará (23:59)",
    "willCallActivated": "Llamará activado",
    "willCallBracket": "[Llamará]",
    "willCallLabel": "llamará",
    "willCallTrip": "Llamará viaje",
    "wmrNumber": "Número WMR",
    "wmrNumberIsRequired": "Se requiere el número WMR",
    "writeYourCommentHere": "Escribe tu comentario aquí...",
    "yamsolLlc": "YAMSOL LLC",
    "year": "Año",
    "yearIsRequired": "Se requiere año",
    "yes": "si",
    "yourCompany": "Tu Empresa",
    "yourLicenseIsGoing": "Su licencia caducará el 22/11/2020. Por favor renueve y actualice su licencia en Hoosier Transportation para evitar cualquier inconveniente.",
    "zipCode": "Código postal",
    "zipCodeIsRequired": "Se requiere código postal",
    "zipIsRequired": "Se requiere código postal",
    "zoneForIsRequired": "Se requiere zona para",
    "zoneName": "Nombre de zona",
    "zones": "Zonas",
    "zoom": "Ampliar",
    "id": "ID",
    "escort": "acompañante",
    "spRate": "SP. Tarifa",
    "estFare": "EST. tarifa",
    "createdTime": "Hora de creación",
    "authNumber": "Número de autorización",
    "appointmentTypes": "Tipos de cita",
    "dvNotes": "Notas DV",
    "source": "Fuente",
    "trackingNo": "Número de seguimiento.",
    "roleOrSource": "Rol/Fuente",
    "staffManager": "Gerente de personal",
    "mobileNumber": "Número de móvil",
    "updatedAt": "Actualizado en",
    "createdAt": "Creado en",
    "version": "Versión",
    "shiftLabel": "turno",
    "role": "Rol",
    "puTime": "Tiempo PU",
    "doTime": "Hora de hacer",
    "puDate": "Fecha de PU",
    "doDate": "HACER Fecha",
    "memberInfo": "Información de miembro",
    "facilityVeh": "Instalaciones - Veh",
    "noMemberName": "No./ Nombre del miembro",
    "dosLabel": "DOS",
    "losLabel": "LOS",
    "pickupTime": "Hora de recogida",
    "dropoffTime": "Hora de entrega",
    "mileage": "Kilometraje",
    "reservationNoLabel": "Reserva No.",
    "claimed": "Reclamado",
    "onboardStatus": "Estado a bordo",
    "insurance": "Seguro",
    "loadTime": "Tiempo de carga",
    "unloadTime": "Tiempo de descarga",
    "totalTrips": "Viajes totales",
    "totalIntake": "Ingesta total",
    "serviceCharges": "Cargos por servicio",
    "companyIntake": "Entrada de la empresa",
    "remainingAmount": "Cantidad restante",
    "cashPayment": "Pago en efectivo",
    "creditPayment": "Pago de crédito",
    "adjustedAmount": "Monto ajustado",
    "balance": "Saldo",
    "driverEarnings": "Ganancias del conductor",
    "earnings": "Ganancias",
    "cash": "efectivo",
    "credit": "Crédito",
    "adjusted": "Ajustado",
    "total": "totales",
    "early": "Temprano",
    "onTime": "A tiempo",
    "late": "tarde",
    "earlyTimeScore": "Puntuación temprana",
    "onTimeScore": "Puntuación a tiempo",
    "lateTimeScore": "Puntuación de retraso",
    "actualOnTimeScore": "Puntuación real a tiempo",
    "aptTime": "Hora APT",
    "arrivedTime": "Hora de llegada",
    "message": "Mensaje",
    "error": "error",
    "sentDate": "Fecha de envío",
    "createdDate": "Fecha de creación",
    "memberId": "ID de miembro",
    "otpStatus": "Estado de la OTP",
    "otpMinutes": "Minutos de OTP",
    "oneHourViolation": "Violación de 1 hora",
    "filePath": "Ruta del archivo",
    "mrnLabel": "Número de registro de miembro (MRN)",
    "timestamps": "Marcas de tiempo",
    "trackId": "ID de seguimiento",
    "location": "Ubicación",
    "report": "Informe",
    "currentMileage": "Kilometraje actual",
    "inspectedBy": "Inspeccionado por",
    "inspectionCenter": "Centro de inspección",
    "result": "Resultado",
    "passed": "APROBADO",
    "failed": "FALLADO",
    "dateCorrected": "FECHA DE CORRECCIÓN",
    "frontDriverPassengerCompartment": "COMPARTIMIENTO DEL CONDUCTOR / PASAJERO",
    "patientCompartment": "COMPARTIMIENTO DEL PACIENTE",
    "exteriorVehicle": "VEHÍCULO EXTERIOR",
    "underHoodCompartment": "DEBAJO DEL CAPÓ / COMPARTIMIENTO",
    "fluidsEngine": "FLUIDOS / MOTOR",
    "brakeTest": "PRUEBA DE FRENO",
    "tiresWheels": "NEUMÁTICOS / RUEDAS",
    "brakes": "FRENOS",
    "bodyFrame": "CUERPO Y MARCO",
    "fuelSystem": "SISTEMA DE COMBUSTIBLE",
    "exhaustSystem": "SISTEMA DE ESCAPE",
    "cost": "Costo",
    "category": "categoría",
    "shiftTime": "Hora del turno",
    "timeInTimeOut": "Tiempo de entrada/tiempo de salida",
    "mealTakenDue": "Comida tomada/pendiente",
    "restTakenDue": "Descanso tomado/debido",
    "workingHours": "Horas de trabajo",
    "breakHours": "Horas de descanso",
    "loadedMilesRate": "Tarifa de Millas Cargadas",
    "deadMilesRate": "Tasa de millas muertas",
    "account": "cuenta",
    "amount": "Cantidad",
    "approxDo": "~ HACER",
    "approxPu": "~PU",
    "approxTimeLabel": "Hora aprox.",
    "approxPuLabel": "Recogida aprox.",
    "approxDoLabel": "Entrega aprox.",
    "currentTrip": "Viaje actual",
    "appt": "cita",
    "arrive": "llegar",
    "arriveDist": "Dist. de llegada",
    "availability": "Disponibilidad",
    "breaksAck": "Se rompe Ack.",
    "breaksDue": "Descansos vencidos",
    "breaksTaken": "Descansos tomados",
    "bucket": "cubo",
    "bumped": "Golpeado",
    "cads": "cads",
    "cancelCharge": "Cancelar cargo",
    "cancelledTrips": "Viajes cancelados",
    "changeReason": "Motivo del cambio",
    "claimAmount": "Monto del reclamo",
    "claimId": "ID de reclamo",
    "claimPaymentAmount": "Monto del pago del reclamo",
    "company": "Empresa",
    "companyIntakeAfterThreshold": "Admisión de la empresa después del umbral",
    "completedTrips": "Viajes completados",
    "components": "Componentes",
    "dateLabel": "Fecha",
    "day": "dia",
    "declined": "Rechazado",
    "distDiff": "Dist. Dif.",
    "distance": "Distancia",
    "distanceViolet": "Distancia Violeta.",
    "doAddress": "HACER dirección",
    "driverIntakeAfterThreshold": "Entrada del conductor después del umbral",
    "dropoffDiff": "Diferencia de caída.",
    "duration": "Duración",
    "engaged": "Comprometido",
    "eta": "ETA",
    "events": "Eventos",
    "fee": "Tarifa",
    "flatFee": "Tarifa fija",
    "fromTime": "Del tiempo",
    "group": "grupo",
    "ignored": "ignorado",
    "lateReason": "Razón tardía",
    "loadUnloadTime": "Tiempo de carga/descarga",
    "loadedMiles": "Millas cargadas",
    "maxFactor": "factor máximo",
    "minimumFare": "Tarifa mínima",
    "netProfit": "Beneficio neto",
    "newDist": "Nuevo distrito.",
    "noOfTrips": "No. de viajes",
    "noShowCharge": "Cargo por no presentarse",
    "odometerStartEnd": "Odómetro inicio-fin",
    "onboardViolet": "Violeta a bordo.",
    "otherViolet": "Otra violeta.",
    "outgoings": "Salidas",
    "passedFailed": "Aprobado/fallido",
    "patientName": "Nombre del paciente",
    "pdOrder": "Orden P/D",
    "perform": "Realizar",
    "performDist": "Realizar dist.",
    "phone": "Teléfono",
    "phoneNo": "Número de teléfono",
    "pickupDiff": "Diferencial de recogida",
    "platformCharges": "Cargos de plataforma:",
    "preDist": "Pre Dist.",
    "price": "Precio",
    "puAddress": "Dirección PU",
    "puDoAddress": "Dirección PU - DO",
    "remaining": "restante",
    "restHours": "Horas de descanso",
    "returned": "Devuelto",
    "rigHash": "Plataforma#",
    "rigType": "Tipo de plataforma",
    "service": "Servicio",
    "serviceDate": "Fecha de servicio",
    "sr": "Sr.",
    "srHash": "Sr#",
    "status": "Estado",
    "timeDifference": "Diferencia horaria",
    "timeStamps": "Marcas de tiempo",
    "timeWise": "En cuanto al tiempo",
    "tip": "consejo",
    "toTime": "Al tiempo",
    "toll": "peaje",
    "totalDeadMileRate": "Tasa total de millas muertas",
    "totalEarning": "Ganancia total",
    "totalEarningsColon": "Ganancias totales:",
    "totalLoadedMileRate": "Tarifa total de millas cargadas",
    "travel": "viajar",
    "tripEarnings": "Ganancias de viaje",
    "willCallStatus": "Estado de llamada",
    "adjustTrips": "Ajustar viajes",
    "amendmentReq": "Se requiere enmienda.",
    "assistRequired": "¿Se requiere ayuda?",
    "associateTo": "Asociado a",
    "broker": "corredor",
    "calculate": "calcular",
    "clientIdMemberId": "ID de cliente/ID de miembro/MA#/AHCCCS#",
    "displayName": "Nombre para mostrar",
    "documentExpiry": "Caducidad del documento",
    "driverGrievanceReport": "Informe de quejas del conductor",
    "driverSignature": "Firma del conductor",
    "generalInformation": "Información general",
    "generateReport": "Generar informe",
    "googleApproximation": "Aproximación de Google",
    "localApproximation": "Aproximación local",
    "ltiReport": "Informe LTI",
    "markConfirmed": "Marca confirmada",
    "markReady": "Marcar listo",
    "unmarkReady": "Desmarcar listo",
    "markUnassigned": "Marcar como no asignado",
    "markVoicemail": "Marcar correo de voz",
    "milesReport": "Informe de Millas",
    "modifierTwo": "Modificador dos",
    "otherReason": "Otra razón",
    "partialEdit": "Edición parcial",
    "plusAdd": "+ Agregar",
    "rating": "Calificación",
    "rawTripSummary": "Resumen del viaje sin procesar",
    "receiverEmail": "Correo electrónico del destinatario",
    "state": "Estado",
    "tripsReport": "Informe de viajes",
    "update": "Actualizar",
    "showing": "Mostrando",
    "entries": "entradas",
    "enterInPercent": "Introduzca en %",
    "enterInPercentage": "Ingrese en porcentaje",
    "selectCorporatePlaceholder": "-- Seleccione Corporativo --",
    "grievance": "Queja",
    "itemLost": "Artículo perdido",
    "generalShift": "Turno General",
    "addCorporate": "Agregar corporativo",
    "addCompanies": "Agregar empresas",
    "Accidental Reports": "Informes accidentales",
    "Addons": "Complementos",
    "Announcements": "Anuncios",
    "Appointment Types": "Tipos de citas",
    "Billing": "Facturación",
    "Business Reports": "Informes comerciales",
    "CheckList": "Lista de verificación",
    "Dashboard": "Panel de control",
    "Availability": "Disponibilidad",
    "Dirt Road": "Camino de tierra",
    "Driver Alerts": "Alertas al conductor",
    "Driver Expense": "Gastos del conductor",
    "Driver Score": "Puntuación del conductor",
    "Driver Wise": "Conductor sabio",
    "EDI 835": "EDI 835",
    "Earnings": "Ganancias",
    "Extras": "Extras",
    "Fleet": "flota",
    "Grievance / Item Lost": "Queja/Artículo perdido",
    "Helping Material": "Material de ayuda",
    "Invoice": "factura",
    "Itineries": "Itinerarios",
    "Maintenance": "Mantenimiento",
    "Manifest": "Manifiesto",
    "Manual": "manuales",
    "Modifier Codes": "Códigos modificadores",
    "Nemt Pro Tips": "Consejos profesionales de Nemt",
    "Operations": "Operaciones",
    "Outbounding": "saliente",
    "Planner": "Planificador",
    "Primary Diagnosis": "Diagnóstico primario",
    "Pro Tips": "Consejos profesionales",
    "Push to Talk": "Empuje para hablar",
    "Rates": "Tarifas",
    "Reports": "Informes",
    "Routing": "Enrutamiento",
    "SMS": "SMS",
    "Statistics": "Estadísticas",
    "Support": "Soporte",
    "TRFs & Claims": "TRF y reclamaciones",
    "TRFs Templates": "Plantillas TRF",
    "Trips": "Viajes",
    "Vehicle Expense": "Gasto del vehículo",
    "Vehicle Inspection": "Inspección de vehículos",
    "Zones": "Zonas",
    "back": "Atrás",
    "next": "Siguiente",
    "previous": "Anterior",
    "upload": "Subir",
    "export": "Exportar",
    "import": "Importar",
    "refresh": "Actualizar",
    "edit": "Editar",
    "view": "Ver",
    "loading": "Cargando...",
    "deselectAll": "Deseleccionar todo",
    "more": "más...",
    "clearFilters": "Borrar filtros",
    "clearFilter": "Borrar filtro",
    "clearAll": "Borrar todo",
    "applyFilters": "Aplicar filtros",
    "applyFilter": "Aplicar filtro",
    "noData": "Sin datos",
    "noResults": "Sin resultados",
    "ok": "OK",
    "filters": "Filtros",
    "Staging": "Puesta en escena",
    "Assigned": "Asignado",

    "memberInfoHeader": "Información del Miembro",
    "serviceInfoHeader": "Información del Servicio",
    "dateTimeHeader": "Fecha y Hora",
    "pickupTimeLabel": "Hora de Recogida",
    "dropoffTimeLabel": "Hora de Entrega",
    "cityLabel": "Ciudad",
    "stateLabel": "Estado",
    "zipCodeLabel": "Código Postal",
    "notesHeader": "Notas",
    "attachmentsHeader": "Archivos Adjuntos",
    "paymentStatus": "Estado de pago",
    "assistedBy": "Asistido por:",
    "insuranceId": "ID de seguro",
    "ipaNumber": "Número de IPA",
    "passengerName": "Nombre del pasajero",
    "cellPhone": "Teléfono celular",
    "dob": "Fecha de nacimiento",
    "clientId": "ID de cliente",
    "forDriver": "Para conductor",
    "actualMiles": "Millas reales",
    "paymentMode": "Modo de pago",
    "deadMinutes": "Minutos muertos",
    "tripMiles": "Millas de viaje",
    "tripTime": "Tiempo de viaje",
    "totalTripMiles": "Millas totales de viaje",
    "totalTripTime": "Tiempo total del viaje",
    "totalTripMilesInclDeadMiles": "Millas totales de viaje (incluidas millas muertas)",
    "totalTripTimeInclDeadMinutes": "Tiempo total de viaje (incluidos minutos muertos)",
    "odometerEnd": "Fin del odómetro",
    "enRoute": "En camino",
    "readySince": "Listo desde:",
    "app": "Aplicación",
    "availabilityDays": "Días de disponibilidad",
    "joiningDate": "Fecha de ingreso",
    "sunday": "Domingo",
    "sun": "Domingo",
    "monday": "Lunes",
    "mon": "Lunes",
    "tuesday": "Martes",
    "tue": "Martes",
    "wednesday": "Miércoles",
    "wed": "Miércoles",
    "thursday": "Jueves",
    "thu": "Jueves",
    "friday": "Viernes",
    "fri": "Viernes",
    "saturday": "Sábado",
    "sat": "Sábado",
    "dayMon": "Lun",
    "dayTue": "Mar",
    "dayWed": "Mié",
    "dayThu": "Jue",
    "dayFri": "Vie",
    "daySat": "Sáb",
    "daySun": "Dom",
    "addressPicker": "Selector de dirección",
    "smsConfiguration": "Configuración de SMS",
    "confirmationTemplate": "Plantilla de confirmación",
    "default": "Predeterminado",
    "boldage": "Boldage"
};
